import classNames from "classnames/bind";
import { Info, WarningCircle } from "@phosphor-icons/react";
import React from "react";
import styles from "./AlertMessage.module.scss";
import type { AlertMessageIconProps } from "./types";

const cx = classNames.bind(styles);

export const AlertMessageIcon = ({ type }: AlertMessageIconProps) => {
  switch (type) {
    case "alert":
      return <WarningCircle className={`${cx("alerticon")}`} />;
    case "info":
      return <Info className={`${cx("infoicon")}`} />;
    case "warning":
      return <WarningCircle className={`${cx("warningicon")}`} />;
  }
};
